import { withInstall, withNoopInstall } from '@bigin/utils'

import Steps from './src/steps.vue'
import Step from './src/item.vue'

export const BSteps = withInstall(Steps, {
  Step,
})
export default BSteps
export const BStep = withNoopInstall(Step)

export * from './src/item'
export * from './src/steps'
